import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import { type Language, type ProjectConfig } from 'tsp-types'

const initialState: Settings = {
  language: (localStorage.getItem('i18nextLng') as Language) ?? 'en',
  projectId: localStorage.getItem('projectId') ?? '',
  projects: [],
}

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setLanguage(state, action) {
      state.language = action.payload
      localStorage.setItem('i18nextLng', action.payload)
    },
    setProjectId(state, action: PayloadAction<Settings['projectId']>) {
      state.projectId = action.payload
      localStorage.setItem('projectId', action.payload)
    },
    setProjects(state, action: PayloadAction<Settings['projects']>) {
      state.projects = action.payload
    },
  },
})

export const { setLanguage, setProjectId, setProjects } = settingsSlice.actions

export default combineReducers({
  settings: settingsSlice.reducer,
})

export interface Settings {
  language: Language
  projectId: string
  projects: ProjectConfig[]
}
